import { Injectable } from '@angular/core';
import { BaseService, Pagination } from '../core';
import { InquiryCreateDto, Inquiry, InquiryDeleteDto, InquiryReplyCreateDto } from '../dto';
import { Store } from '@ngrx/store';
import * as IndicatorStore from '../store/indicator';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InquiryService extends BaseService {
  constructor(private store: Store<any>) {
    super();
  }
  sendInquiry(inquiryCreateDto: InquiryCreateDto) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('sendInquiry'));
    return super.post<Inquiry>('/inquiry', inquiryCreateDto).pipe(
      mergeMap((inquiry) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('sendInquiry'));
        return of(inquiry);
      })
    );
  }

  getInquiryList(pagination: Pagination) {
    return super.paginate<Inquiry>('/inquiry', pagination);
  }

  getInquiryById(id: number) {
    return super.get<Inquiry>(`/inquiry/${id}`);
  }

  removeInquiry(inquiryIds: InquiryDeleteDto) {
    return super.delete('/inquiry', inquiryIds);
  }

  sendReply(id: number, inquiryReplyCreateDto: InquiryReplyCreateDto) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('sendReply'));
    return super.post<Inquiry>(`/inquiry/${id}/reply`, inquiryReplyCreateDto).pipe(
      mergeMap((inquiry) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('sendReply'));
        return of(inquiry);
      })
    );
  }
}
